export type ApproverBalance = {
  employee_id: string
  figures: { leave_type: string; balance_days: string | number; pending_days: string | number }[]
  taken_sl_days: string | number
}

export type BalanceFigure = {
  code: string
  name: string
  remaining: number
  pending: number
  overdrawn: boolean
}

/** Decimals arrive as strings; what is left is the balance less every request still awaiting a verdict. */
export function balanceFigures(balance: ApproverBalance): BalanceFigure[] {
  return balance.figures.map((figure) => {
    const pending = Number(figure.pending_days)
    const remaining = Number(figure.balance_days) - pending
    return {
      code: figure.leave_type.split(' - ')[0],
      name: figure.leave_type,
      remaining,
      pending,
      overdrawn: remaining < 0,
    }
  })
}

export const LEAVE_DAY_MODE = 'L - Leave'

/** A leave day is marked on the day or on any one of its lines. */
export function dayCarriesLeave(day: { mode: string; lines: { work_mode?: string }[] }): boolean {
  return day.mode === LEAVE_DAY_MODE || day.lines.some((line) => line.work_mode === LEAVE_DAY_MODE)
}
